import type { TabPanelContext, TabPanelPassThroughOptions, TabPanelProps } from 'primevue/tabpanel';
import TabPanel from 'primevue/tabpanel';
import type { PassThrough } from 'primevue/ts-helpers';
import type { Component } from 'vue';
import { defineComponent, h } from 'vue';

export interface DsTabPanelProps {
    uniformTabWidth?: boolean;
}

/**
 * Contains direct pass through options for the TabPanel component
 * that proved hard to overwrite in DsDataTable
 */
export const DsTabPanelPassThroughOptions = (props?: DsTabPanelProps): PassThrough<TabPanelPassThroughOptions> => {
    return {
        header: {
            class: ['ds-tab-header text-content-lg font-bold', { 'flex-1': props?.uniformTabWidth }],
        },
        headerAction: ({ context }: { context: TabPanelContext }) => {
            const classes = ['py-3 px-4 no-underline justify-center'];
            return {
                class: [...classes, context.active ? 'text-content-primary border-b-none' : 'text-content-secondary'],
                style: {
                    borderTopLeftRadius: '0 !important',
                    borderTopRightRadius: '0 !important',
                    backgroundColor: 'transparent !important',
                    borderBottom: 'none !important',
                },
            };
        },
        headerTitle: {
            class: 'text-content-lg font-medium decoration-none text-content-primary',
        },
    };
};

/** Proxy for the TabPanel component with a DsName and predefined pass through options */
export const DsTabPanel: Component<TabPanelProps> = defineComponent({
    name: 'TabPanel',
    inheritAttrs: false,
    setup(_, { attrs, slots }) {
        return () =>
            h(
                TabPanel,
                {
                    ...attrs,
                },
                slots,
            );
    },
});
